import React, { useEffect } from "react";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import AuthStack from "./Auth";
import useAuth from "../contexts/Auth/useAuth";
import HomeTabs from "./AppStack";
import AppProvider from "../contexts/AppContext";
import PageContainer from "../components/PageContainer";
import { HomeTabsParams } from "./AppStack/HomeTabParams";
import { WalletStackRoute } from "./AppStack/routes";
import { UploadFileScreenRoute } from "./WalletStack/routes";
import { ImageReceived } from "../../App";

interface NavigationProps {
  sharedImage: ImageReceived | null;
  initialRoute?: string;
  initialParams?: Record<string, any>;
}

const Navigation = ({ sharedImage, initialRoute, initialParams }: NavigationProps) => {
  const { user, isAuthenticating } = useAuth();
  const navigation = useNavigation<NavigationProp<HomeTabsParams>>();

  // Handle image shared into the app when user is logged in
  useEffect(() => {
    if (!isAuthenticating && user && sharedImage) {
      navigation.navigate(WalletStackRoute, {
        screen: UploadFileScreenRoute,
        params: { image: sharedImage },
      });
    }
  }, [isAuthenticating, user, sharedImage]);

  return (
    <PageContainer loading={isAuthenticating}>
      {!!user ? (
        <AppProvider>
          <HomeTabs />
        </AppProvider>
      ) : (
        // Pass initialRoute and params to AuthStack
        <AuthStack initialRoute={initialRoute} initialParams={initialParams} />
      )}
    </PageContainer>
  );
};

export default Navigation;